interface GuideHubPreferences {
  gettingStartedVisible: boolean;
}

type StoredGuideHubPreferences = Record<string, GuideHubPreferences>;

export const guideHubPreferencesStorageKey = (baseKey: string): string =>
  `${baseKey}:guide-hub-preferences:v1`;

export const readGettingStartedVisible = (
  storageKey: string,
  userLogin: string | null
): boolean => {
  if (!userLogin) return true;
  try {
    const stored = JSON.parse(
      localStorage.getItem(storageKey) ?? '{}'
    ) as StoredGuideHubPreferences;
    const visible = stored[userLogin]?.gettingStartedVisible;
    return typeof visible === 'boolean' ? visible : true;
  } catch {
    return true;
  }
};

export const writeGettingStartedVisible = (
  storageKey: string,
  userLogin: string | null,
  visible: boolean
): void => {
  if (!userLogin) return;
  let stored: StoredGuideHubPreferences = {};
  try {
    stored = JSON.parse(
      localStorage.getItem(storageKey) ?? '{}'
    ) as StoredGuideHubPreferences;
  } catch {
    // Replace invalid local preferences without blocking the guide hub.
  }
  stored[userLogin] = { gettingStartedVisible: visible };
  try {
    localStorage.setItem(storageKey, JSON.stringify(stored));
  } catch {
    // A blocked/quota-limited storage must never make the guide unusable.
  }
};
